<template>
    <div class="ti1">抱歉!</div>
    <div class="ti1">当前页面不存在...</div>
    <div class="ti1">请检查您输入的网址是否正确，或点击下面的按钮返回首页。</div>
</template>
<style lang="scss" scoped>
.ti1 {
  font-size: 16px;
  color: #303133;
}
</style>